import Swiper from "swiper";
window.Swiper = Swiper;
import "swiper/css/swiper.min.css";
